import React, { Component } from 'react'
import '../styles/Navbar.css'
import { Link } from "react-scroll";
import {NavLink} from 'react-router-dom'

export default class Navbar extends Component {

    render() {
        return (
            <>
                <nav className="navbar navbar-expand-lg">
                    <div className="container">
                        <NavLink className="navbar-brand text-center" to="/">
                            <img src="./logo.png"/>
                            <span>Courses Hub</span>
                        </NavLink>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"><img src="../images/mozy.png" alt="mozy"/></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mr-auto">
                                <li className="nav-item active">
                                    <NavLink exact className="nav-link" to="/">Home</NavLink>
                                </li>
                                <li className="nav-item">
                                    <Link smooth={true} className="nav-link" to="about">About</Link>
                                </li>
                                <li className="nav-item">
                                    <Link smooth={true}className="nav-link" to="services">Services</Link>
                                </li>
                                <li className="nav-item">
                                    <Link smooth={true} className="nav-link" to="statistics">Statistics</Link>
                                </li>
                                <li className="nav-item dropdown">
                                    <a className="nav-link dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Courses
                                    </a>
                                    <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <Link smooth={true} className="dropdown-item" to="courses">Courses List</Link>
                                        <NavLink className="dropdown-item" to="/UpComing">Upcoming</NavLink>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <Link smooth={true} className="nav-link" to="footer">Contact us</Link>
                                </li>
                            </ul>
                            <NavLink to="/SignIn" className="login signin">Sign in</NavLink>
                            <NavLink to="/SignUp" className="login signup">Sign up</NavLink>
                        </div>
                    </div>
                </nav>
            </>
        )
    }
}
